<template>
    <div class="panorama-inner">
        <search-panorama
            :query="query"
            v-model="panoramaQuery"
            :annotationOptions="annotationOptions"
            :apenafs="apenafs"
            :subjects="subjects"
            :displayedSubjects="displayedSubjects"
            :insurers="insurers"
            :minNumberOfSubjects="2"
            :haveConventions="conventions.length > 0"
            :loading="loading"
        />
        <div v-if="!loading && hasConventions" class="results-wrapper">
            <panorama-results
                :conventions="conventions"
                :displayedSubjects="displayedSubjects"
                :insurers="insurers"
                :annotationOptions="annotationOptions"
                :apenafsByCode="apenafsByCode"
                :minNumberOfDisplayedSubjects="2"
                :panoramaQuery="panoramaQuery"
            />
        </div>
        <div v-if="!loading && !hasConventions" class="results-wrapper">
            <panorama-no-results
                :panoramaQuery="panoramaQuery"
                :annotationOptions="annotationOptions"
                :subjects="displayedSubjects"
                :insurers="insurers"
            />
        </div>
        <div v-if="loading" class="results-wrapper">
            <panorama-loading
                :displayedSubjects="displayedSubjects"
                :minNumberOfDisplayedSubjects="2"
            />
        </div>
        <panorama-pagination
            v-if="conventions.length > 0"
            :pageNumber="pageNumber"
            :totalConventions="totalConventions"
            :numberOfPages="numberOfPages"
            :pageSize="10"
            @change="onPaginationChange"
        />
    </div>
</template>

<script>
import SearchPanorama from "./search/SearchPanorama.vue";
import PanoramaResults from "./PanoramaResults.vue";
import PanoramaLoading from "./PanoramaLoading.vue";
import { Services } from "src/services/Services";
import { EventBus } from "src/bus/eventBus";
import { parseQuery } from "./helpers/query-formatter";
import { orderBy } from "lodash";
import PanoramaPagination from "./PanoramaPagination.vue";
import PanoramaNoResults from "./PanoramaNoResults.vue";

export default {
    components: {
        SearchPanorama,
        PanoramaResults,
        PanoramaLoading,
        PanoramaPagination,
        PanoramaNoResults,
    },
    props: ["annotationOptions", "insurers", "apenafsByCode", "subjects"],
    data() {
        return {
            conventions: [],
            query: {},
            pageNumber: 0,
            numberOfPages: null,
            totalConventions: 0,
            panoramaQuery: this.getPanoramaQuery(),
            loading: false,
            displayedSubjects: [],
        };
    },
    async mounted() {
        this.displayedSubjects = this.subjects;
        EventBus.$on("subjectsChanged", async displayedSubjects => {
            this.displayedSubjects = displayedSubjects;
            this.query = parseQuery(this.query, this.panoramaQuery, displayedSubjects);
            await this.updateSearch();
        });

        this.query = parseQuery(this.query, this.panoramaQuery, this.displayedSubjects);
        await this.updateSearch();
    },
    methods: {
        getPanoramaQuery() {
            if (localStorage.getItem("panoramaQuery")) {
                const storedPanoramaQuery = JSON.parse(localStorage.getItem("panoramaQuery"));
                this.query = parseQuery(this.query, storedPanoramaQuery, this.displayedSubjects);
                return storedPanoramaQuery;
            } else {
                return {};
            }
        },
        async updateSearch() {
            this.loading = true;
            try {
                const { conventions, numberOfPages, totalConventions } =
                    await Services.api.convention.getSearchablePanorama({
                        ...this.query,
                        page: this.pageNumber,
                    });
                this.numberOfPages = numberOfPages;
                this.totalConventions = totalConventions;
                this.conventions = conventions;
            } catch (e) {
                // TODO handle error
            } finally {
                this.loading = false;
            }
        },
        onPaginationChange(pageNumber) {
            this.pageNumber = pageNumber;
            this.updateSearch();
        },
    },
    computed: {
        apenafs() {
            return orderBy(this.apenafsByCode, "code");
        },
        hasConventions() {
            return this.conventions && this.conventions.length > 0;
        },
    },
    watch: {
        async panoramaQuery(newPanoramaQuery) {
            localStorage.setItem("panoramaQuery", JSON.stringify(newPanoramaQuery));
            this.query = parseQuery(this.query, newPanoramaQuery, this.displayedSubjects);
            this.pageNumber = 0;
            await this.updateSearch();
        },
    },
};
</script>

<style scoped lang="sass">
.results-wrapper
    margin: 0 $grid-gutter $grid-gutter

.pagination
    display: flex
    align-items: center
    justify-content: center

.pagination-text
    padding-right: 16px
</style>
